import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");
const log = Utils.log;

class Command extends Base<any> {

    static about = `
This is intended to be a generic validator to whatever extent that is possible but the current use-case is this:
The 'zone-validation' arguments contain a count of the number of intersecting zones; if that count is non-zero it is an error

Usage Example:

    <EVENT about="If no features are clicked..." event="map-or-feature-click" id="feature-is-not-click-validator" mid="app/commands/validator" type="action">
    <OPTIONS>
        <Values about="No feature clicked, clear existing features, perform reverse geocoding, show the click location" id="event" value="clear-features-from-layer,reverse-geoquery" />
        <Values about="We don't want any zones!" id="max-result-count" value="0" />
        <Values about="Do not trigger if there is at least one feature" id="trigger-invalid" value="false" />
        <Values id="debug" value="false" />
        <Values about="Clears the features from the parcel-features layers" id="layer-name" value="parcel-features,address-features" />
    </OPTIONS>
    </EVENT>

    `;

    static options = {
        'max-result-count': {
            "about": 'valid when there are at most this many results',
            "default": "",
        },
        'min-result-count': {
            "about": 'valid when there are at least this many results',
            "default": "",
        },
        'trigger-valid': {
            "about": 'trigger when validate',
            "default": "true",
        },
        'trigger-invalid': {
            "about": 'trigger when invalidate',
            "default": "true",
        },
    }

    static output = {
        "reason": {
            "about": "The reason validation failed or succeeded",
            "domain": "no_layers_found|count_out_of_bounds",
        },
        "valid": {
            "about": "Result of validity test",
            "domain": "true|false",
        },
    }

    execute(args: any = this.args) {

        let min = this.findOption("min-result-count");
        let max = this.findOption("max-result-count");
        let triggerValid = "false" !== this.findOption("trigger-valid");
        let triggerInvalid = "false" !== this.findOption("trigger-invalid");

        if (min || max) {

            let count = 0;
            let events = <Array<{ eventArgs: any; eventName: string; }>>this.findArg("events", args).events;
            if (events && Array.isArray(events)) {
                events.forEach(event => {
                    log(`searching ${event.eventName}`);
                    let layers = <[{ count: number, features: [] }]>this.findArg("layers", event.eventArgs).layers;
                    if (layers && Array.isArray(layers)) {
                        layers.forEach(l => count += l.count !== undefined ? l.count : l.features.length);
                    }
                });
            }
            else {
                let layers = <{ layers: [{ count: number, features: [] }] }>this.findArg("layers", args);

                if (layers && Array.isArray(layers.layers)) {
                    layers.layers.forEach(l => count += l.count !== undefined ? l.count : l.features.length);
                } else {
                    triggerInvalid && this.trigger({
                        valid: false,
                        reason: "no_layers_found"
                    });
                    return;
                }
            }

            if (min && count < parseInt(min)) {
                triggerInvalid && this.trigger({
                    valid: false,
                    reason: "count_out_of_bounds"
                });
                return;
            }
            if (max && count > parseInt(max)) {
                triggerInvalid && this.trigger({
                    valid: false,
                    reason: "count_out_of_bounds"
                });
                return;
            }
        }

        triggerValid && this.trigger({
            valid: true
        });
    }

}

export = Command; 